module.exports = __webpack_public_path__ + "img/login-logo.1653de61.png";